/**
 * Wordmark component — design.md §6.1, branding.md §4.1.
 *
 * Two-tone: "proof" renders in var(--text), the trailing "." renders in
 * var(--accent). One mark, no separate prefix glyph.
 *
 * Geist 500, letter-spacing −0.01em. Lowercase. Integral trailing period.
 *
 * Accent usage rule (design.md §2): accent reserved for go-to pills,
 * current-variation indicators, primary CTAs, sub-mode active underlines,
 * diff arrows, editor keywords, agent-suggestion borders, save-state dots,
 * and focus rings. The wordmark trailing period is explicitly part of this
 * reserved set — it is the primary brand signal element.
 */

import type { HTMLAttributes } from "react";

interface WordmarkProps extends HTMLAttributes<HTMLSpanElement> {
  /** Rendered size. Defaults to inherited font-size. */
  size?: string | number;
}

export function Wordmark({ size, style, ...rest }: WordmarkProps) {
  const sizeStyle: React.CSSProperties = size
    ? { fontSize: typeof size === "number" ? `${size}px` : size }
    : {};

  return (
    <span className="wordmark" style={{ ...sizeStyle, ...style }} aria-label="proof." {...rest}>
      <span className="wordmark__letters" aria-hidden="true">
        proof
      </span>
      {/* The trailing period renders in --accent per design.md §6.1 */}
      <span className="wordmark__period" aria-hidden="true">
        .
      </span>
    </span>
  );
}
